import { useEffect, useState } from "react";
// import YouTube from "react-youtube";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export interface VideoInfo {
  videoId: string;
  isShorts: boolean;
  thumbnailUrl: { url: string; fallbackUrl: string };
  embedUrl: string;
  videoUrl: string;
}

export function VideoPlayer({
  className,
  info,
  onClose,
}: {
  className?: string;
  info: VideoInfo;
  onClose: () => void;
}) {
  const [videoSize, setVideoSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    console.log("VideoPlayer, ", info);
    const windowSize = { width: window.innerWidth, height: window.innerHeight };

    const aspectRatio = info.isShorts ? 9 / 16 : 16 / 9;
    const maxWidth = windowSize.width * 0.9;
    const maxHeight = windowSize.height * 0.9;

    let width, height;

    if (info.isShorts) {
      height = maxHeight;
      width = height * aspectRatio;
      if (width > maxWidth) {
        width = maxWidth;
        height = width / aspectRatio;
      }
    } else {
      width = maxWidth;
      height = width / aspectRatio;
      if (height > maxHeight) {
        height = maxHeight;
        width = height * aspectRatio;
      }
    }

    setVideoSize({ width, height });
  }, [info]);

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const handleBackgroundClick = (e: React.MouseEvent) => {
    // 배경 영역이 클릭된 경우에만 닫기
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className={cn(
        "fixed inset-0 z-50 bg-black/80 flex items-center justify-center animate-fade-in",
        className,
      )}
      onClick={handleBackgroundClick}
    >
      <Button
        variant="ghost"
        size="icon"
        className="absolute top-4 right-4 text-white"
        onClick={onClose}
      >
        <X className="h-6 w-6" />
      </Button>
      {/* <YouTube
        videoId={info.videoId}
        opts={{
          width: videoSize.width,
          height: videoSize.height,
          playerVars: {
            autoplay: 0, // 자동재생 비활성화
            controls: 1, // 컨트롤러 표시
            modestbranding: 1, // YouTube 로고 최소화
            rel: 0, // 관련 동영상 표시 안함
            fs: 1, // 전체화면 버튼 활성화
            logging: 0, // 로깅 비활성화
          },
        }}
        //className="absolute top-0 left-0 w-full h-full"
        //iframeClassName="w-full h-full"
      /> */}
      <iframe
        src={info.embedUrl}
        title="YouTube video"
        allowFullScreen
        width={videoSize.width}
        height={videoSize.height}
        style={{ border: "none" }}
      ></iframe>
    </div>
  );
}
